module.exports = __webpack_public_path__ + "static/media/arrow-filter.626d7de2.svg";